export default __webpack_public_path__ + "static/worried-116160302241cca2a49d7ba62e0ea0cd.png";